import { boolean, intersect, literal, partial, string, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as JobId } from '../../../job/Id';
import { Id as StageId } from '../../../job/stage/Id';
import { Id as TransactionId } from '../../../transaction/Id';
import { Id as UserId } from '../../../user/Id';

export const Request = intersect(
	union(
		intersect(
			struct({
				type: literal('announcement'),
			})
		)(
			partial({
				title: string,
				message: string,
				details: string,
				persistent: boolean,
				toast: boolean,
				subType: union(literal('new-version-available')),
			})
		),
		struct({
			type: literal('chat'),
			message: string,
			jobOrTransactionId: union(JobId, TransactionId),
			chatChannelArn: string,
			messageId: string,
		}),
		struct({
			type: literal('job-assignment'),
			jobId: JobId,
			stageId: StageId,
		}),
		struct({
			type: literal('transaction-unassigned'),
			transactionId: TransactionId,
		}),
		struct({
			type: literal('transaction-assignment'),
			transactionId: TransactionId,
			stageId: StageId,
		}),
		struct({
			type: literal('transaction-completed'),
			transactionId: TransactionId,
		}),
		struct({
			type: literal('job-completed'),
			jobId: JobId,
		}),
		struct({
			type: literal('job-created'),
			jobId: JobId,
		})
	)
)(
	partial({
		userId: UserId,
		delaySec: iotsUtils.PositiveInteger,
	})
);
